import { useEffect, useState } from 'react';

const KEY = 'theme';
const COLORS = { dark: '#0f1419', light: '#f4f5f7' };

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'light' || t === 'dark' ? t : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', COLORS[theme]);
}

export function setTheme(theme) {
  try { localStorage.setItem(KEY, theme); } catch { /* storage unavailable: theme still applies for this session */ }
  applyTheme(theme);
  window.dispatchEvent(new Event('themechange'));
}

export function useTheme() {
  const [theme, setLocal] = useState(getTheme);
  useEffect(() => {
    const onChange = () => setLocal(getTheme());
    window.addEventListener('themechange', onChange);
    return () => window.removeEventListener('themechange', onChange);
  }, []);
  return [theme, setTheme];
}
